import React from "react";
import ReactDOM from "react-dom/client";
import { CookiesProvider } from "react-cookie";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import './App.scss'
import ScrollToTop from "./ScrollToTop";
import { measureWebVitals, initPerformanceMonitoring } from './utils/performance';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.Fragment>
        <BrowserRouter>
        <ScrollToTop />
        <CookiesProvider>
            <App />
        </CookiesProvider>,
        </BrowserRouter>
    </React.Fragment>
);

// Register service worker for caching
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
            .then((registration) => {
                console.log('SW registered: ', registration);
            })
            .catch((registrationError) => {
                console.log('SW registration failed: ', registrationError);
            });
    });
}

// Performance monitoring
if (process.env.NODE_ENV === 'development') {
    window.addEventListener('load', () => {
        setTimeout(() => {
            try {
                initPerformanceMonitoring();
            } catch (error) {
                console.log('Performance monitoring failed:', error);
            }
        }, 1000);
    });
}
